var chunkMapping = {
	"71": [
		90071
	],
	"2840": [
		82840
	]
};
var idToExternalAndNameMapping = {
	"82840": [
		"default",
		"./AdsBannerList",
		862
	],
	"90071": [
		"default",
		"./LiveCommerce",
		862
	]
};
var idToRemoteMap = {
	"82840": [
		{
			"externalType": "script",
			"name": "remote",
			"externalModuleId": 862
		}
	],
	"90071": [
		{
			"externalType": "script",
			"name": "remote",
			"externalModuleId": 862
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}